<script setup>
defineProps({
  value: { type: Number, required: true },
})
</script>

<template>
  <div>
    <p class="flex items-baseline justify-between">
      <span class="text-3xl font-bold text-up-orange">
        {{ value }}%<span class="ml-2 text-base font-medium text-up-navy">concluído</span>
      </span>
    </p>
    <div
      class="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-200"
      role="progressbar"
      :aria-valuenow="value"
      aria-valuemin="0"
      aria-valuemax="100"
      aria-label="Progresso da manutenção"
    >
      <div class="h-full rounded-full bg-up-orange transition-[width] duration-500" :style="{ width: `${value}%` }" />
    </div>
  </div>
</template>
